/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Blog_TitleInputs */

const en_directory_home_blog_title = /** @type {(inputs: Directory_Home_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inside the scorecard: how Seek AI vets every tool`)
};

const zh_directory_home_blog_title = /** @type {(inputs: Directory_Home_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评分卡里有什么：Seek AI 如何严选每一个工具`)
};

/**
* | output |
* | --- |
* | "Inside the scorecard: how Seek AI vets every tool" |
*
* @param {Directory_Home_Blog_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_blog_title = /** @type {((inputs?: Directory_Home_Blog_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Blog_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_blog_title(inputs)
	return zh_directory_home_blog_title(inputs)
});
export { directory_home_blog_title as "directory.home.blog_title" }